import * as types from './types'

export const mutations = {
	[types.FETCH_NOTIFICATIONS] (state, { notifications }) {
		state.notifications = notifications
	},
	[types.OPEN_NOTIF] (state) {
		state.open = true
	},
	[types.CLOSE_NOTIF] (state) {
		state.open = false
	}
}



// WEBPACK FOOTER //
// ./src/common/store/Notifications/mutations.js